import { LOAD_UPLOAD_DATA, SET_UPLOAD_STATUS } from '../helpers/types';

const INITIAL_STATE = {
  uploadData: [],
  isLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOAD_UPLOAD_DATA:
      return {
        ...state,
        uploadData: action.payload,
        isLoading: false,
      };
    case SET_UPLOAD_STATUS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
